import MainComponent from "components/Main";
import ContentBlock from "components/ContentBlock";

import './index.less';
import './themes/default.less';
import EmployeePortfolio from "../employeePortfolio";


/**
 * Created by viclight on 04.03.2024.
 */
export default class EmployeeData extends MainComponent {


    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            absol: true,
        };
    }


    renderRow(title, component, color, key) {
        const props = {};
        if (key !== undefined)
            props.key = "Row" + key;

        return (
            <div className="detailRow flex text p1 gap8" {...props}>
                <div className="rowTitle">{this.tr(title)}</div>
                <div className={`${color ? "compColor" + color : ""} flex1`}>{component}</div>
            </div>
        );
    }
    renderAddInfo(info)
    {
        const { email, address, workPhone, snils } = info;

        return (
            <div className="content flex col gap8">
                {workPhone && this.renderRow("employee.telWork", <div>{workPhone}</div>)}
                {snils && this.renderRow("СНИЛС", <div>{snils}</div>)}
                {email && this.renderRow("employee.email", <div>{email}</div>, "Blue")}
                {address && this.renderRow("employee.portfolio", <EmployeePortfolio address={address} />)}
            </div>
        );
    }

    getSpecsText(arr)
    {
        if (arr.length > 0) {

            let t_arr = arr.map((it)=>it.specEntity.title);
            return t_arr.join(", ");

        }
        return "";
    }

    getClinicFullname(id, clarr) {
        let obj = clarr.find((it) => {
            return it.id === id;
        });

        if (obj !== undefined) {
            return obj.fullName;
        }

        return "";
    }

    renderProfileInfo(info)
    {
        const { isDoctor, specs, domainId, education, characteristic, experienceBeginning } = info;
        const { clinics } = this.props;

        const _experience = (experienceBeginning !== null) ? this._helper.getEmployeeExpirienceLabel(experienceBeginning.split("-")[0]) : "";

        return (
            <div className="content flex col gap8">
                {this.renderRow("employee.specialization", <div>{isDoctor ? this.getSpecsText(specs) : this.tr("employee.specializationNot")}</div>)}
                {this.renderRow("employee.experience", <div>{_experience}</div>)}
                {this.renderRow("employee.clinicName", <div>{this.getClinicFullname(domainId, clinics)}</div>)}
                {this.renderRow("employee.education", <div>{education}</div>)}
                {this.renderRow("employee.characteristic", <div>{characteristic}</div>)}
            </div>
        );
    }

    renderHistory(info) {
        const { changedBy, changedTime, createdBy, createdTime } = info;

        const created = `${this._helper.string.formatFullName(this.props.getDoctorById(createdBy), "short")} ${this._helper.date.toStr(createdTime, "D MMMM YYYY")}`;
        const revision = `${this._helper.string.formatFullName(this.props.getDoctorById(changedBy), "short")} ${this._helper.date.toStr(changedTime, "D MMMM YYYY")}`;

        return (
            <div className="content flex col gap4">
                {this.renderRow("client.created", <div>{created}</div>)}
                {this.renderRow("client.revision", <div>{revision}</div>)}
            </div>
        );
    }

    render() {

        const { name, openRightPopup, info, clinics } = this.props;

        return (
            <div className="tabsPage pos rel flex1 flex minH0">
                <div className={`pageContent flex flex1 scrolling ${name}`}>
                    <div className="wrapGeneral flex flex1 gap16">
                        <div className="columnContent flex col flex1 gap16">
                            <ContentBlock
                                title="employee.addInfoSection"
                                icons={[
                                    {
                                        name: "edit",
                                        onClick: openRightPopup.bind(this, "editInfoData", info, this.props.updateProfile)
                                    }]}>
                                {this.renderAddInfo(info)}
                            </ContentBlock>
                        </div>
                        <div className="columnContent flex col flex1 gap16">
                            <ContentBlock
                                title="employee.profileSection"
                                icons={[
                                    {
                                        name: "edit",
                                        onClick: openRightPopup.bind(this, "editProfileData", info, this.props.updateProfile, clinics)
                                    }]}>
                                {this.renderProfileInfo(info)}
                            </ContentBlock>
                            <ContentBlock title="client.history">
                                {this.renderHistory(info)}
                            </ContentBlock>
                        </div>
                    </div>
                </div>
            </div>
        );

    }


}
